<header class="map-bar">

    <div class="map-bar__inner">

        <div class="map-bar__group">

            <button type="button" class="bar-btn" title="خروج از حساب کاربری" (click)="clickMethod('name')">
                <i class="fa fa-power-off"></i>
            </button>

            <button type="button" class="bar-btn" title="به روز رسانی اطلاعات" (click)="reload()">
                <i class="fa fa-rotate-right"></i>
            </button>

            <button type="button" class="bar-btn" *ngIf="!deviceInfo && !bDonotShowMap" title="نمایش لیست خودروها"
                (click)="openMenuCar()">
                <i class="fa fa-car"></i>
            </button>

            <button type="button" class="bar-btn" *ngIf="isHubEnabled && isHubConnect"
                [title]="isLiveTracking ? 'قطع کردن ردیابی زنده' : 'شروع ردیابی زنده'" (click)="toggleLiveTracking()">
                <i class="fa" [ngClass]="isLiveTracking ? 'fa-unlink' : 'fa-plug'"></i>
            </button>

            <button type="button" class="bar-btn" title="داشبورد وضعیت ناوگان" (click)="openSafetyDashboard()">
                <i class="fa fa-line-chart"></i>
            </button>

        </div>

        <!-- logo | Hub Connection Status -->
        <div class="map-bar__center" *ngIf="deviceInfo">
            <ng-container *ngIf="isHubEnabled && !isHubConnect; else fleetyarLogo;">
                <ng-container *ngIf="isHubConnect == false;else recconectButton;">
                    <div class="loader-container">
                        <p class="map-bar__offline"> ... قطع ارتباط با هاب سامانه، سعی بر برقراری مجدد ارتباط </p>
                        <div class="header-loader mx-2" aria-label="در حال بارگذاری"></div>
                    </div>
                </ng-container>
                <ng-template #recconectButton>
                    <button type="button" class="bar-reconnect" (click)="reConnectHub()">
                        اتصال به هاب
                    </button>
                </ng-template>
            </ng-container>
            <ng-template #fleetyarLogo>
                <img class="map-bar__logo" src="../../../assets/Img/fleetYar_Typo.png" width="140px" alt="فیلیت یار">
            </ng-template>
        </div>

        <button type="button" class="bar-btn" title="منو" (click)="openMenu()">
            <i class="fa fa-bars fa-lg" aria-hidden="true"></i>
        </button>

    </div>

</header>

<div *ngIf="!bDonotShowMap" id="test" class="fixed-map-main">

    <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

    <div class="position-absolute" id="map_tooltips" data-bs-html="true"></div>

    <div class="fixed-area-choose">

        <div class="geo-pill" *ngIf="deviceInfo && acssess.bEnableGeoFance">

            <i *ngIf="editMode" class="geo-pill__btn geo-pill__btn--edit fa fa-pencil fa-2x" title="ویرایش"
                (click)="editArea()"></i>

            <i class="geo-pill__btn geo-pill__btn--del fa fa-trash fa-2x" title="حذف محدوده" (click)="deleteArea()"
                *ngIf="deviceInfo && acssess.bDeleteGeoFance"></i>

            <select class="form-select geo-pill__select" (change)="GeoFence($event.target)" id="areaSelection"
                [value]="GeoFenceId"
                title="محدوده‌های ثبت‌شده روی نقشه؛ با انتخاب هر محدوده، خودروهای داخل آن و تحلیل ورود/خروج نمایش داده می‌شود">

                <option value="-1" class="text-center vazir">— انتخاب محدوده —</option>

                <option class="text-center vazir" *ngFor="let item of GeoFenceData" value="{{item.iGeoFence}}">

                    {{item.strTitle}}</option>

            </select>

            <i class="geo-pill__btn geo-pill__btn--add fa fa-plus-circle fa-2x" title="اضافه کردن محدوده"
                (click)="addInteraction()"></i>

        </div>

    </div>

    <div class="icon-Map position-absolute index d-flex flex-column">

        <button type="button" class="map-tool" title="نمایش همه خودروها در یک کادر" (click)="fitMap()">
            <img src="../../../assets/Img/selectAll.png" alt="نمایش همه">
        </button>

        <div class="layers-container position-relative">
            <button type="button" class="map-tool" [class.guide-pulse]="showGuide" title="لایه‌های نقشه"
                (click)="hasTrafficAccess ? toggleLayersContainer() : changeTail()">
                <img src="../../../assets/Img/layer-icon.png" alt="لایه‌ها">
            </button>
            <div class="guide-container" *ngIf="showGuide">
                از این قسمت می‌توانید نقشه ماهواره‌ای با دقت بالاتر را انتخاب کنید.
            </div>
            <!-- لایه های نقشه -->
            <ng-container *ngIf="hasTrafficAccess && bShowLayers">
                <div class="layers-panel position-absolute row gx-2 dir-rtl"
                    style="top: 0px;left:-240px;width: 228px;z-index: 2;">
                    <div *ngFor="let layer of mapLayers; let i = index" class="layers-panel__item col-6 p-1 pointer"
                        [class.layer-disabled]="layer.disabled" (click)="changeTail(layer.id)">
                        <div class="rounded w-100 d-flex flex-column align-items-center justify-content-center p-1">
                            <div class="w-100" style="height: 53px;max-height: 53px;">
                                <img class="w-100 h-100"
                                    [ngClass]="iLayer.includes(layer.id) ? 'border border-2 border-warning' : ''"
                                    style="object-fit: cover;border-radius: 10px;" [src]="layer.imageUrl"
                                    [alt]="layer.name">
                            </div>
                            <span class="my-1" style="font-size: 14px;">{{ layer.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="layers-arrow position-absolute"
                    style="width: 20px;height: 20px;top: 11px;left:-28px;rotate: 48deg;z-index: 1;">
                </div>
            </ng-container>
        </div>

        <button type="button" *ngIf="deviceInfo && acssess.bPDF" class="map-tool map-tool--danger"
            [disabled]="exportPdf" (click)="exportPdfMap()" title="خروجی PDF نقشه">
            <i class="fa fa-file-pdf-o"></i>
        </button>

        <a *ngIf="(!isHubEnabled && !isHubConnect) && (deviceInfo && acssess.bLive)" class="map-tool map-tool--accent"
            href="/tracker/trackAll" target="_blank" rel="noopener" title="نمایش بر خط همه خودرو ها">
            <i class="fa fa-car"></i>
        </a>
    </div>

</div>

<div class="position-fixed bg-secondary menu-bg" id="bg-menu" (click)="closeMenu()"></div>

<div *ngIf="bDonotShowMap" class="position-fixed bg-primary menu-bg">
    <img src="../../../assets/Img/wall-5.jpg" width="100%" height="100%" style="object-fit: cover;" alt="">
</div>

<!-- منوی مدیریت خمل و نقل  -->
<menu_item class="position-absolute bg-white h90 index-3 d-none"
    (tripModal)="tripModal($event)" (modalMenu)="showModal($event)">
</menu_item>

<!-- منوی پی سپار -->
<menu-peysepar class="position-absolute bg-white col-xl-2 col-lg-3 col-md-4 col-8 h90 index-3 d-none"
    (modalMenu)="showModal($event)" (holidayData)="holidayData($event)">
</menu-peysepar>

<!-- منوی اصلی برنامه -->
<menu_car class="position-absolute col-md-4 col-11  index-3" *ngIf="!bDonotShowMap" (carGroup)="filterCarMap($event)"
    (carIdOut)="showModal($event)" (locationTable)="addAlarmOnMap($event)" [item]="allCar" [dataWorkTa]="dataWorkTa"
    [dataWorkAz]="dataWorkAz" [GeoFence]="GeoFenceId" [dataPolygans]="datasabtPolygan">
</menu_car>

<!--Footer-->
<footer class="position-fixed footer w-100 index-footer map-footer">
    <div class="map-footer__inner">
        <div class="d-flex flex-row my-auto pointer index-2">
        </div>
        <div class="position-absolute sos">
            <button class="btn btn-danger circel " *ngIf="false && !deviceInfo && acssess.bEnableSOS"
                (mousedown)="handelSos()" (mouseup)="handelLeve()" (touchstart)="handelSos()"
                (touchend)="handelLeve()">SOS</button>
        </div>
        <div class="map-footer__brand" *ngIf="deviceInfo && acssess.bShowRayan">
            <a href="https://rayanandisheh.com" target="_blank" rel="noopener">
                {{appName | faNum}}
                <small>{{version | faNum}}</small>
            </a>
        </div>

        <div class="map-footer__mouse">
            <div id="mouse-position"></div>
        </div>
    </div>
</footer>

<!-- ModalSaveCar -->
<save-car-modal [form]="datasabt" [access]="acssess" (guideRequested)="guid()" (submitted)="sabt()">
</save-car-modal>

<!-- Modal Menu-->
<report-period-modal [formFrom]="dataPeriodAz" [formTo]="dataPeriodTa" [title]="modalMenuTitle"
    [reportId]="menuModalId" (confirmed)="report($event)">
</report-period-modal>

<!-- Modal Move In Area-->
<area-move-modal [form]="datasabtPolygan"></area-move-modal>

<!-- Modal analysis -->
<geo-fence-analysis-modal [deviceInfo]="deviceInfo" [access]="acssess" (moveInAreaClicked)="hideTooltip()">
</geo-fence-analysis-modal>

<!--Save Poygan-->
<geo-fence-save-modal [nameControl]="polyganName" [editMode]="editMode" (saved)="savePolygon()"
    (edited)="submitEditedTitle()">
</geo-fence-save-modal>

<!--Report analysis-->
<area-report-modal [formFrom]="dataWorkAz" [formTo]="dataWorkTa"></area-report-modal>

<!--Exel Uploder-->
<excel-upload-modal (browseRequested)="openUploder()" (fileSelected)="fileChange($event)" (saved)="saveFile()">
</excel-upload-modal>

<!-- Modal-Help -->
<help-modal [webAppName]="webAppName" [helpData]="helpData"></help-modal>

<!-- Modal Holidays -->
<holidays-modal [years]="holidaySelection" [holidays]="holidays" (yearChanged)="changeHolidayYear($event)"
    (addRequested)="setNewHolidayModal()" (deleteRequested)="deleteHoliday($event)">
</holidays-modal>

<!-- Modal add holiday -->
<add-holiday-modal [form]="datasabt" (saved)="saveHoliday()"></add-holiday-modal>

<!-- Trip Modal -->
<trip-modal [isOpen]="bShowTripComp" (closed)="tripModal(false)"></trip-modal>

<!-- expired cars component -->
<expired-cars-modal [isOpen]="bExpiredComp"></expired-cars-modal>

<!-- Fleet Status Modal -->
<fleet-status-modal></fleet-status-modal>
